module.exports = __webpack_public_path__ + "img/imageGalery1.64806d04.jpg";